<template>
  <SearchSelect
    :all-string="'Tutti i partecipanti'"
    :model-value="modelValue"
    :name="name"
    :options="companies"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup>
import SearchSelect from "@/components/list/SearchSelect.vue";
import useAxios from "@/composables/axios";

const axios = useAxios()

const companyResp = await axios.get('/company/list')
const companies = companyResp.data.reduce((options, company) => {
  options[company.uuid] = company.name;
  return options;
}, {})

defineProps({
  name: {
    type: String,
    required: true
  },

  modelValue: {
    type: String,
    default: ''
  }
})

defineEmits(['update:modelValue'])
</script>